import { IUiState } from './ui-manager.state';
import { UiStates } from './ui-states.enum';

export const hasUiState = (uiState: IUiState, state: UiStates): boolean => {
    return containsUiState(uiState.states, state);
};

export const containsUiState = (states: UiStates[], state: UiStates): boolean => {
    return states.some((s) => s === state);
};
